import { StepperHorizontalData } from "../../../../../../data/formsAndTable/forms/FormLayout";
import { StepperProp } from "../../../../../../types/Forms";

const StepperHorizontal: React.FC<StepperProp> = ({ step, finishClicked }) => {
  return (
    <>
      {StepperHorizontalData.map((data, index) => (
        <div key={index} className={`step ${step > index + 1 || finishClicked === true ? "done active " : ""}`}>
          <div className="step-circle">
            <span>{index + 1}</span>
          </div>
          <div className="step-title">{data}</div>
          <div className="step-bar-left" />
          <div className="step-bar-right" />
        </div>
      ))}
    </>
  );
};
export default StepperHorizontal;
